// UI reducer types
export const SET_ERRORS = "SET_ERRORS"
export const SET_SUCCESS = "SET_SUCCESS"
export const CLEAR_ERRORS = "CLEAR_ERRORS"
export const LOADING_UI = "LOADING_UI"
export const STOP_LOADING_UI = "STOP_LOADING_UI"
